export default {
  requestsInProgress: 0,
  referralHistory: {
    employeeLedReferrals: 0,
    managerLedReferrals: 0,
    manualReferrals: 0,
    totalReferrals: 0,
    employeeWellbeingReferrals: [],
    employeeDeclinedWellbeingReferrals: [],
  },
  current: null,
  list: {
    content: [],
    pagination: {
      sort: {
        orders: [
          { property: "isAbsent", direction: "DESC" },
          { property: "lastName", direction: "ASC" },
        ],
      },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  modals: {
    addEmployee: {
      visible: false,
      employee: null,
    },
    addEmployeeChooseClient: {
      visible: false,
    },
    contactInfo: {
      visible: false,
    },
    homePageSettings: {
      visible: false,
    },
    changePassword: {
      visible: false,
    },
    absenceDetails: {
      visible: false,
    },
  },
  schema: null,
  addEmployeeSchema: null,
  draft: null,
  employeeFilterInitialValues: {
    isActive: "true",
  },
};
